import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { NonMemberActivityService } from '../../Services/nonMemberActivity.service';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';

import Swal from 'sweetalert2';
import * as $ from 'jquery';

@Component({
  selector: 'app-subscription-list-non-member-edit',
  template: require('./subscription-list-non-member-edit.component.html'),
  styles: [require('./subscription-list-non-member-edit.component.css')]
})

export class SubscriptionListNonMemberComponent implements OnInit {
  loading: boolean = false;
  amountOFColspan:number = 7;
  activityId = 0
  subscriberList:any=[]
  amountPayed:number = 0;

  activity:any={
    id:0,
    price: 0,
    description: ''
  }

  nonmember:any={
    id: 0,
    firstName: '',
    lastName: '',
    email: '',
    remarks: '',
    gsm: '',
    team: '',
    birthday: '',
    gender: '',
    streetName: '',
    houseNr: '',
    postalCode: '',
    community: '',
    extraQuestion: false,
    amount: 1,
  }

  selectedBirthday: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor(  
          private route: ActivatedRoute,
          private auth: AuthService, 
          private nonMemberActivityService: NonMemberActivityService
         ) {
      
      route.params.subscribe(p => {
        if (p['id'])
          this.activityId = +p['id'];
        else
          this.activityId = 0;
      });
  }

  ngOnInit() {
    this.loadSubscribers()
    this.loadActivityById()
  }

  loadSubscribers(){
    this.nonMemberActivityService.getAllSubscriptionsForActivity(this.activityId).subscribe( (res:any)=>{
      if (res.status == 200){
        this.subscriberList = res.value
        this.calculateAmountPayed()
      }     
    })
  }

  loadActivityById(){
    this.nonMemberActivityService.getNonMemberActivitiesById(this.activityId).subscribe( (res:any)=>{
      // console.log(res);
      if (res.status == 200){
        this.activity = res.value
        // console.log(this.activity);
        if (this.activity.askGsm) this.amountOFColspan +=1;
        if (this.activity.askTeam) this.amountOFColspan +=1;
        if (this.activity.askBirthday) this.amountOFColspan +=1;
        if (this.activity.extraQuestion) this.amountOFColspan +=1;
        if (this.activity.askGender) this.amountOFColspan +=1;
        if (this.activity.askAddress) this.amountOFColspan +=1;
        if (this.activity.askNationality) this.amountOFColspan +=1;
      }
    } )
  }

  checkHasPayedFull(id: any){
    var item = this.subscriberList.find( (x:any) => x.id == id)  
    if (item){   
      return item.hasPayedFull;
    }
    else{
      return false;
    }
  }

  calculateAmountPayed(){
    var count = 0;
    this.subscriberList.forEach( (element:any)=>{
      if (element.hasPayedFull){
        count ++
      }
    } )
    this.amountPayed = count;
  }


  copyEmailAdressesToClipBoard(){
    var addresses: string= "";
    this.subscriberList.forEach( (element:any)=>{
      var email = element.email
      if (email.length > 0){
        addresses += email+";"
      }          
    })

    this.copyMessage(addresses);
    Swal.fire({
      // title: '',
      text: "Alle email adressen gekopieerd naar het clipboard",
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok',
    })
  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  editSub(id:number){
    var sub = this.subscriberList.find( (s:any)=> s.id == id )
    // console.log(sub)

    var bd = new Date(sub.birthday);
    this.selectedBirthday = {
      jsdate: bd,
      date:{year: bd.getFullYear(), month: bd.getMonth() +1, day: bd.getDate()}
    };    
    this.nonmember = sub;
    (<any>$('#newNonMemberSubscriptionModal')).modal();
  }

  deleteSub(id: number){
    // console.log("delete sub with id:", id);
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je deze inschrijving wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.nonMemberActivityService.deleteSubsciptionFromActivity(id).subscribe( (res:any)=>{
          // console.log("Result of delete: ", res);
          this.loadSubscribers()
        })
      }
    });
  }

  checkboxPayedFullClicked(id: any) {
    var sub = this.subscriberList.find( (s:any)=> s.id == id )
    sub.hasPayedFull = !sub.hasPayedFull

    this.nonMemberActivityService.updateSubsciptionFromActivity(sub).subscribe( (res:any)=>{
      this.calculateAmountPayed()
    })
    
  }

  showMessage(s:string){
    Swal.fire({
      showCancelButton:false,
      cancelButtonText: "Annuleren",
      title: "Opmerking: ",
      type: "info",
      // text: 'Welk type fietsen neem je mee?',
      input: 'textarea',
      inputAttributes: {
        "readonly": "",
        "style": "color: darkgrey;background-color: lightgrey;"
      },
      inputValue: s
    })
  }

  clearInput(){
    this.nonmember = {
      id: 0,
      firstName: '',
      lastName: '',
      email: '',
      remarks: '',
      gsm: '',
      team: '',
      birthday: '',
      gender: '',
      streetName: '',
      houseNr: '',
      postalCode: '',
      community: '',
      extraQuestion: false,
      amount: 1,
    }
    this.selectedBirthday={};
  }


  SaveNonMemberSubscription(){
    // console.log("SaveNonMemberSubscription");
    // console.log(this.nonmember);


    this.nonmember['NonMemberActivityId'] = this.activity.id
    this.nonmember.birthday = String(this.selectedBirthday.date.year)+"-"+String(this.selectedBirthday.date.month)+"-"+String(this.selectedBirthday.date.day)

    this.nonMemberActivityService.create(this.nonmember).subscribe( res =>{
      // console.log("Create:")
      // console.log(res);

      if (res.status == 200){
        this.loadSubscribers()
        this.clearInput()
      }
    })
  }

  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/subscription-list-non-member-edit/subscription-list-non-member-edit.component.ts